module.exports = __webpack_public_path__ + "static/media/cares.9e8e9716.svg";